import { createContext } from 'react';
import {
    DealerAddressType,
    ProductType,
    VehicleType
} from '../components/common/CommonTypes';
import { ProgressBarItem } from '../components/common/progressBar/ProgressBar';
import {
    TyrePageState,
    TyreProcessStages
} from '../components/sitePages/tyreRepairRequest/TyreRepairRequestTypes';

export type TyreRepairRequestContextState = {
    product: ProductType;
    vehicle: VehicleType;
    progressBarItems: ProgressBarItem[];
    tyreRepairRequest: TyrePageState;
    onSelectTyreType: (selectionName: string) => void;
    onChangeMileage: (value: string) => void;
    onTyreValueChange: (key: string, value: string) => void;
    onTyreRepairRequestChangeTyre: (value: string, key: string) => void;
    onTyreSelected: (tyre: string) => void;
    onChangeDamageType: (selectionName: string) => void;
    onRepairAddressSelectionChanged: (selectedIndex: number) => void;
    onDealerAddressUpdate: (dealerAddres: DealerAddressType) => void;
    onUploadImageChange: (
        imageType: string,
        uploadedPath: string,
        imageId: string,
        image: string,
        filename: string
    ) => void;
    onTogglePermission: (isChecked: boolean) => void;
    onFinishedTyreRepairRequest: () => void;
    onCancelClick: () => void;
    onCancelRepairRequest: () => void;
    onCancelUndo: () => void;
    onChangeStage: (stage: TyreProcessStages) => void;
    onUpdateTyreClick: (tyre: string) => void;
    onUpdateAddressClick: (scrollToAddress: boolean) => void;
    onContinueRepairRequest: () => void;
    onContinueToRepairAddress: () => void;
    onFinishAddingTyres: () => boolean;
    onDeleteRepairRequest: (tyre: string) => void;
    onChangDateOfIncident: (value: string) => void;
};

const initialState: TyreRepairRequestContextState = {
    product: undefined,
    vehicle: undefined,
    progressBarItems: undefined,
    tyreRepairRequest: undefined,
    onSelectTyreType: undefined,
    onChangeMileage: undefined,
    onTyreValueChange: undefined,
    onTyreRepairRequestChangeTyre: undefined,
    onTyreSelected: undefined,
    onChangeDamageType: undefined,
    onRepairAddressSelectionChanged: undefined,
    onDealerAddressUpdate: undefined,
    onUploadImageChange: undefined,
    onTogglePermission: undefined,
    onFinishedTyreRepairRequest: undefined,
    onCancelClick: undefined,
    onCancelRepairRequest: undefined,
    onCancelUndo: undefined,
    onChangeStage: undefined,
    onUpdateTyreClick: undefined,
    onUpdateAddressClick: undefined,
    onContinueRepairRequest: undefined,
    onContinueToRepairAddress: undefined,
    onFinishAddingTyres: undefined,
    onDeleteRepairRequest: undefined,
    onChangDateOfIncident: undefined
};

export const TyreRepairRequestContext = createContext(initialState);
